import moment from "moment";
import { AppDispatch } from "../../app/store";
import { PersonInterface } from "../../common/interfaces/PersonInterface";
import { enableMobileNumberCheckModal } from "../../app/rootReducer";
import { setDateError, setDateErrorText } from "./FormSlice";

const dutchZipcodeRegex = /^[1-9]\d{3}\s?[a-z]{2}$/i;
const belgiumZipcodeRegex = /^[1-9]\d{3}$/;

export function isZipCodeFormatValid(zipCode: string | undefined): boolean {
    return !!(
        zipCode &&
        (dutchZipcodeRegex.exec(zipCode) ||
            belgiumZipcodeRegex.exec(zipCode) ||
            zipCode.length === 0)
    );
}

export function conditionalFieldError(
    outerMatch: boolean,
    errorForm: boolean,
    innerInvalid: boolean,
    message: string,
): string | false {
    if (outerMatch) {
        if (errorForm && innerInvalid) {
            return message;
        }
        return false;
    }
    return false;
}

export function trimmedFieldError(
    value: string | null | undefined,
    errorForm: boolean,
    message: string,
): string | false {
    if (value?.trim()) {
        if (errorForm && !value?.trim()) {
            return message;
        }
        return false;
    }
    return false;
}

export function invalidFieldError(
    errorForm: boolean,
    isInvalid: boolean,
    message: string,
): string | false {
    if (errorForm && isInvalid) {
        return message;
    }
    return false;
}

export function submitPersonalForm(params: {
    damageDate: string | null | undefined;
    person: PersonInterface;
    dispatch: AppDispatch;
    setErrorForm: (value: boolean) => void;
}): void {
    const { damageDate, person, dispatch, setErrorForm } = params;

    if (!damageDate) {
        setErrorForm(true);
        return;
    }

    const currentDamageDate = moment(damageDate).format("YYYY-MM-DD");

    if (
        moment(currentDamageDate).isBefore(
            moment().subtract(1, "year").subtract(1, "day"),
        ) ||
        moment(currentDamageDate).isAfter(moment())
    ) {
        if (
            moment(currentDamageDate).isBefore(
                moment().subtract(1, "year").subtract(1, "day"),
            )
        ) {
            dispatch(
                setDateErrorText(
                    "Wij accepteren geen aanvragen van meer dan 1 jaar geleden.",
                ),
            );
            return;
        }

        dispatch(setDateErrorText("De datum kan niet in de toekomst liggen."));
        dispatch(setDateError(true));
        return;
    }

    dispatch(setDateError(false));
    setErrorForm(false);

    if (
        !person?.first_name?.trim() ||
        !person?.last_name?.trim() ||
        !person?.email?.includes("@") ||
        !person?.address?.zip_code ||
        !person?.address?.house_number ||
        !person?.address?.street ||
        !person?.address?.city ||
        !person?.mobile_number?.trim() ||
        !currentDamageDate
    ) {
        setErrorForm(true);
        return;
    }

    dispatch(enableMobileNumberCheckModal());
}
